"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicColumnsAdminPageNew = void 0;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const FiltersBar_1 = require("@juvare/common-data-table-ui/FiltersBar");
const showFormDialog_1 = require("@juvare/common-form-ui/showFormDialog");
const PageHeader_1 = require("@juvare/common-web-ui/PageHeader");
const SnackbarHelper_1 = require("@juvare/common-web-ui/SnackbarHelper");
const hooks_1 = require("../../../../../ui/hooks");
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const Cached_1 = __importDefault(require("@mui/icons-material/Cached"));
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const useDynamicColumnList_1 = require("../../hooks/useDynamicColumnList");
const prepareAddDynamicColumnRequest_1 = require("../../utils/prepareAddDynamicColumnRequest");
const DynamicColumnConfigProvider_1 = __importDefault(require("../DynamicColumnConfigProvider"));
const dynamicColumnStatusMap_1 = require("../dynamicColumnStatusMap");
const DynamicColumnSlideout_1 = require("./Components/DynamicColumnSlideout");
const addDynamicColumnFormConfig_1 = require("./FormConfigs/addDynamicColumnFormConfig");
const DynamicColumnsAdminPageNew = (props) => {
    const dynamicColumnConfigContext = react_1.default.useContext(DynamicColumnConfigProvider_1.default);
    const dynamicColumnClient = (0, hooks_1.useDynamicColumnClient)();
    if (!dynamicColumnConfigContext.columnHandlers) {
        console.error('Make sure component is wrapped with DynamicColumnConfigProvider');
    }
    const { dataTableProps, filtersBarProps, reload, clearActiveRow } = (0, DataTable_1.useDataTableUsingUrl)({
        useDataProvider: (request) => (0, useDynamicColumnList_1.useDynamicColumnsList)(request),
        onRowClick: () => undefined,
        rowSelectionEnabled: true,
        defaultSortColumnKey: '',
        maxUrlSearchLength: 200,
    });
    function showAddDynamicColumnsDialog() {
        (0, showFormDialog_1.showFormDialog)({
            title: 'Custom Field',
            config: (0, addDynamicColumnFormConfig_1.addDynamicColumnFormConfig)(props.entities, dynamicColumnConfigContext.columnHandlers),
            onSubmit: (data) => dynamicColumnClient.addColumn((0, prepareAddDynamicColumnRequest_1.prepareAddDynamicColumnRequest)(data, dynamicColumnConfigContext)).then(() => {
                (0, SnackbarHelper_1.showAlertSnackbar)({
                    message: 'Field saved',
                    type: 'success',
                });
                reload();
            }),
        });
    }
    const filterConfig = (0, FiltersBar_1.useFilterConfig)((builder) => {
        builder.quickFilterSelect({
            dataPath: 'entity',
            label: 'Entity',
            values: props.entities.map((entity) => ({ label: entity, value: entity })),
            widget: 'form.select',
            dataTest: 'entity-quick-search',
        });
        builder.quickFilterSelect({
            dataPath: 'status',
            label: 'Status',
            widget: 'form.select',
            values: Object.entries(dynamicColumnStatusMap_1.dynamicColumnStatusMap).map(([key, value]) => ({
                label: value,
                value: key,
            })),
            dataTest: 'status-quick-search',
        });
    }, []);
    const columns = react_1.default.useMemo(() => {
        return [
            {
                headerLabel: 'Entity',
                cellFunction: (row) => react_1.default.createElement(DataTable_1.TextCell, null, row.entity),
            },
            {
                headerLabel: 'Name',
                cellFunction: (row) => react_1.default.createElement(DataTable_1.TextCell, null, row.name),
            },
            {
                headerLabel: 'Status',
                cellFunction: (row) => react_1.default.createElement(DataTable_1.TextCell, null, dynamicColumnStatusMap_1.dynamicColumnStatusMap[row.status]),
            },
        ];
    }, []);
    return (react_1.default.createElement(material_1.Box, { sx: { height: '100%', overflow: 'auto' } },
        react_1.default.createElement(PageHeader_1.PageHeaderWithImage, { gradient: 'blue-base', title: 'Custom Field' }),
        react_1.default.createElement(material_1.Box, { p: 4 },
            react_1.default.createElement(DataTable_1.DataTable, Object.assign({ mainAction: {
                    icon: react_1.default.createElement(Add_1.default, null),
                    label: 'New',
                    onClick: showAddDynamicColumnsDialog,
                }, secondaryAction: {
                    icon: react_1.default.createElement(Cached_1.default, null),
                    label: 'Reload',
                    onClick: reload,
                }, title: 'Custom Field' }, dataTableProps, { columns: columns, filtersBar: react_1.default.createElement(FiltersBar_1.FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })), tableSx: { tableLayout: 'fixed' } }))),
        !!dataTableProps.activeRowId && (react_1.default.createElement(DynamicColumnSlideout_1.DynamicColumnSlideout, { id: dataTableProps.activeRowId, rowsPerPage: dataTableProps.rowsPerPage, page: dataTableProps.page, onClearActiveRow: clearActiveRow, onReload: reload, onBeforeDelete: props.onBeforeDelete }))));
};
exports.DynamicColumnsAdminPageNew = DynamicColumnsAdminPageNew;
